import * as _ from "moment";
import { constant } from "../constants/contant";
import { truncateText } from '../utils/common.utils';

const moment = (_ as any).default;
export interface EventProps {
  attributes: any;
  id: string;
  links: object;
  relationships: any;
  type: string;
  lang: string;
  included: any;
  facets: any;
}

export interface EventState {
  list: EventProps[];
  loading: boolean;
  requestUrl: string;
  dates: Date[];
  highlight: EventProps;
  highlightId: number | null;
  facetsLoaded: boolean;
  included: any[];
  nextPage: string;
  highlightIncluded: any[];
  selectedEvent: any;
  selectedEventIncluded: any[];
  eventStatus: boolean;
  eventDomainField: string | null;
}

export class Event {
  constructor(public props: EventProps) {}

  get fullDate(): string {
    const field_event_date_display_one =
      this.props.attributes?.field_event_date_display_one;
    return field_event_date_display_one;
  }

  get hebrewDate(): string {
    const field_event_date_display_two =
      this.props.attributes?.field_event_date_display_two;
    return field_event_date_display_two;
  }

  get time(): string {
    const field_event_time_display =
      this.props.attributes?.field_event_time_display;
    return field_event_time_display;
  }
  get eventStartDate(): string {
    const field_event_start_date =
      this.props.attributes?.field_event_start_date;
    return moment(field_event_start_date).format("DD");
  }

  get eventEndDate(): string {
    const field_event_end_date =
        this.props.attributes?.field_event_end_date;
    return moment(field_event_end_date).format("DD");
  }

  get isSameDateMonth() {
    const { field_event_start_date, field_event_end_date }: any = this.props?.attributes;
    const startDate = moment(field_event_start_date);
    const endDate = moment(field_event_end_date);
    return startDate.isSame(endDate, 'month');
  }

  get date(): string {
    const field_event_start_date =
      this.props.attributes?.field_event_start_date;
    return moment(field_event_start_date).format("DD");
  }

  get month(): string {
    const field_event_start_date =
      this.props.attributes?.field_event_start_date;
    return constant[this.props.lang].VARIABLES.CALENDAR_MONTHS[
      moment(field_event_start_date).month()
    ];
  }
  get startDayMonth(): string {
    const { field_event_start_date }: any = this.props.attributes;
    const startDate = moment(field_event_start_date);
    return constant[this.props.lang].VARIABLES.CALENDAR_MONTHS[startDate.month()];
  }

  get endDayMonth(): string {
    const { field_event_end_date }: any = this.props.attributes;
    const endDate = moment(field_event_end_date);
    return constant[this.props.lang].VARIABLES.CALENDAR_MONTHS[endDate.month()];
  }

  get day(): string {
    const { field_event_start_date }: any = this.props.attributes;
    return constant[this.props.lang].VARIABLES.DAYS_IN_WEEK[
      moment(field_event_start_date).day()
    ];
  }

  get startTime(): string {
    const { field_event_start_date }: any = this.props.attributes;
    return moment(field_event_start_date).format("hh:mm");
  }

  get endTime(): string {
    const { field_event_end_time }: any = this.props.attributes;
    return moment(field_event_end_time).format("hh:mm");
  }

  get type(): string {
    const field_event_type = this.props.attributes?.field_event_type;
    const eventType: any = Object.keys(this.props.facets?.data).filter(
      (key) =>
        this.props.facets?.data[key]?.value === field_event_type &&
        this.props.facets.data[key]?.id === "event_type"
    );
    return this.props?.facets?.data[eventType]?.label;
  }

  get title(): string {
    const title = this.props.attributes?.title;
    return title;
  }

  get subTitle(): string {
    const field_sub_title = this.props.attributes?.field_sub_title;
    return field_sub_title;
  }

  // Create truncated version of event subtitle.
  get subTitleTrimmed(): string {
    const maxChars = 120;
    const sub_title = this.props.attributes?.field_sub_title;
    return  truncateText(sub_title, maxChars);
  }

  get isOnlineEvent(): boolean {
    const field_event_mode = this.props.attributes?.field_event_mode;
    return field_event_mode === constant.DRUPAL_FIELDS.ONLINE_EVENT;
  }
  get isCombinedEvent(): boolean {
    const field_event_mode = this.props.attributes?.field_event_mode;
    return field_event_mode === constant.DRUPAL_FIELDS.COMBINED_EVENT;
  }
  get isPhysicalEvent(): boolean {
    const field_event_mode = this.props.attributes?.field_event_mode;
    return field_event_mode === constant.DRUPAL_FIELDS.PHYSICAL_EVENT;
  }

  get inviteType(): string | null {
    const field_event_audience = this.props.attributes?.field_event_audience;
    return field_event_audience
      ? constant[this.props.lang].VARIABLES.AUDIENCE[field_event_audience] || null
      : null;
  }

  get cost(): string {
    const field_cost_amount = this.props.attributes?.field_cost_amount;
    return field_cost_amount
      ? `${field_cost_amount} ${constant[this.props.lang].VARIABLES.PAID}`
      : constant[this.props.lang].VARIABLES.FREE;
  }

  get bannerUrl(): string {
      
    if (this.props?.included && this.props?.relationships) {
      
      const { field_featured_media_image }: any = this.props.relationships;
      let mediaFile = this.props.included.filter(
        (include: any) => include.id === field_featured_media_image.data.id
      )[0];
      
      if (mediaFile?.relationships) {
        mediaFile = this.props.included.filter(
          (include: any) =>
          include.id === mediaFile.relationships.thumbnail.data.id
          )[0];

        return `${constant.URL}${mediaFile.attributes.uri.url}`;
      }
      return "";
    }
    return "";
  }

  get calEvents(): any[] {
    const field_event_cal_links_ctm_text =
      this.props.attributes?.field_event_cal_links_ctm_text;
    if (field_event_cal_links_ctm_text) {
      const domains = field_event_cal_links_ctm_text.split("custom_sep");
      return domains.map((domain: string) => ({
        value: domain.split(":")[0],
        url: domain.substr(domain.search(":") + 1),
      }));
    }

    return [];
  }

  get url(): string {
    const { drupal_internal__nid }: any = this.props.attributes;
    return `${constant.URL}/node/${drupal_internal__nid}`;
  }

  get programUrl(): { url: string; label: string } | null {
    if (this.props?.included?.length > 0 && this.props?.relationships) {
      const { field_event_program }: any = this.props.relationships;
      
      if (field_event_program && field_event_program.data) {
        let programUrl = this.props.included.filter(
          (include: any) => include.id === field_event_program.data?.id
        )[0];
        if (programUrl) {
          const fileName = programUrl.attributes.filename;
          return {
            url: `${constant.URL}${programUrl.attributes.uri.url}`,
            label: field_event_program.data?.meta?.description,
          };
        }
        return null;
      }
    }
    return null;
  }

  get cta(): { url: string; hasCta: boolean, text: string } {
    let ctaText = constant[this.props.lang].VARIABLES.ENROLLMENT
    if (this.props.attributes.field_event_action_button === "registration_only") {
      ctaText = constant[this.props.lang].VARIABLES.REGISTRATION_ONLY
    }
    else if (this.props.attributes.field_event_action_button === "registration_and_payment") {
      ctaText = constant[this.props.lang].VARIABLES.REGISTRATION_AND_PAYMENT
    }
    else if (this.props.attributes.field_event_action_button === "enter") {
      ctaText = constant[this.props.lang].VARIABLES.ENTER_EVENT
    }
    else if (this.props.attributes.field_event_action_button === "other") {
      ctaText = this.props.attributes.field_action_button_label
    }
    return {
      url: this.props.attributes?.field_action_button_link?.uri || "",
      hasCta: this.props.attributes?.field_event_action_button !== "no_action",
      text: ctaText,
    };
  }

  get drupalInternalId(): number {
    const { drupal_internal__nid }: any = this.props.attributes;
    return drupal_internal__nid;
  }

  get contact(): {
    email: string;
    title: string;
    url: string;
    phone: string;
    phoneLabel: string;
    hasContact: boolean;
  } {
    const field_event_phone = this.props?.attributes?.field_event_phone;
    const field_email = this.props?.attributes?.field_email;
    const field_link = this.props?.attributes?.field_link;
    let field_backup_phone,
        field_backup_mail,
        field_backup_link;
    
    //backup
    const contact_backup_id =
      this.props?.relationships.field_contact_data.data?.id;
    if (contact_backup_id) {
      const contact_backup_data = this.props.included.filter(
        (include: any) => include.id === contact_backup_id
      )[0];
      field_backup_phone = contact_backup_data.attributes.field_phone;
      field_backup_mail = contact_backup_data.attributes.field_email;
      field_backup_link = contact_backup_data.attributes.field_link;
    }

    const hasPhone = field_event_phone?.first && field_event_phone?.second;
    const hasLink = field_link?.title && field_link?.uri;

    const details: any = {
      phoneLabel: hasPhone ? field_event_phone?.first : field_backup_phone?.first || null,
      phone: hasPhone ? field_event_phone?.second : field_backup_phone?.second || null,
      email: field_email || field_backup_mail || null,
      title: hasLink ? field_link?.title : field_backup_link?.title || null,
      url: hasLink ? field_link?.uri : field_backup_link?.uri || null,
    };

    return {
      hasContact:
        Object.keys(details).filter((key: string) => details[key] !== null)
          .length > 0,
      ...details,
    };
  }

  get hasData(): boolean {
    return this.props.included && this.props.included.length > 0;
  }

  get body(): string {
    return this.props.attributes?.body?.value || "";
  }

  get accessabilityData(): string {
    return this.props.attributes?.field_event_accessibility_data || "";
  }

  get comments(): string {
    return this.props.attributes?.field_event_comments || "";
  }

  get checkoutUrl(): string {
    return this.props.attributes?.field_zoom_link?.uri || null;
  }

  eventFields(lang: string): any[] {
    let cost = constant[lang].VARIABLES["NO_COST"];
    if (this.props.attributes?.field_event_cost !== "free") {
      cost = this.props.attributes?.field_cost_amount
        ? `${this.props.attributes?.field_cost_amount} ש"ח`
        : "";
    }
  let eventMode = constant[lang].VARIABLES.ONLINE_EVENT;

    if(this.isPhysicalEvent) {
       eventMode = constant[lang].VARIABLES.PHYSICAL_EVENT;
    }else if(this.isCombinedEvent) {
      eventMode = constant[lang].VARIABLES.COMBINED_EVENT;

    }
    
    return [
      {
        value: `${this.props.attributes?.field_event_date_display_full}${this.props.attributes.field_event_date_display_two ? ', ' + this.props.attributes.field_event_date_display_two.replace('Day ', '') : ''}`,
        icon: "calendar",
        lable: "EVENT_DATES",
        type: "text",
      },
      {
        value: this.props.attributes?.field_event_time_display || null,
        icon: "time",
        lable: "EVENT_TIME",
        type: "text",
      },
      {
        value: this.props.attributes?.field_event_location,
        icon: "location",
        lable: "EVENT_LOCATION",
        type: "text",
      },
      {
        value: this.props.attributes?.field_zoom_link?.uri || null,
        icon: "location",
        lable: "EVENT_LINK",
        type: "link",
      },
      {
        value: cost,
        icon: "price",  
        lable: "EVENT_COST",
        type: "text",
      },
      {
        value: eventMode,
        icon: "type",
        lable: "EVENT_TYPE",
        type: "text",
      },
      {
        value: this.inviteType,
        icon: "audience",
        lable: "EVENT_AUDIENCE",
        type: "text",
      },
    ];
  }
}
